import React, { Component } from 'react'
import styled from 'styled-components'
import classNames from 'classnames';
import { Mobile, Desktop } from '../../../media'

import ChevronDown from '../../../images/chevron_select.svg'
import ChevronUp from '../../../images/chevron_select_up.svg'

const Wrapper = styled.div`
    > h2 {
        margin-top: 0;
        margin-bottom: 0;
        background: #EDEDED;
        border-bottom: 1px solid #CCCCCC;
        padding: 12px 15px 11px 15px;
        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        text-align: left;
        text-transform: uppercase;
        line-height: 16px;
    }

    > h2.mobile {
        cursor: pointer;
        background-image: url(${ChevronDown});
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        background-size: 18px 11px;
    }

    > h2.mobile.expanded {
        background-image: url(${ChevronUp});
    }

    > div {

        &.mobile {
            display: none !important;     
        }
    
        &.mobile.expanded {
            display: block !important;
        }

        > ul {
            margin-top: 10px;
            margin-bottom: 9px;
    
            > li {
                font-family: Lato-Regular;
                font-size: 14px;
                color: #2B2B2B;
                text-align: left;
                line-height: 22px;
            }
        }
    
        > ul.mobile.table.expanded {
            display: table !important;
        }
    
        > ul.table {
            display: table;
            margin-top: 10px;
            margin-bottom: 14px;
            padding-left: 15px;
            padding-right: 15px;
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
    
            > li {
                display: table-row;
    
                > span {
                    display: table-cell;
                    font-family: Lato-Regular;
                    font-size: 14px;
                    color: #2B2B2B;
                    text-align: left;
                    line-height: 22px;
                    margin-left: 15px;
                    margin-right: 15px;
                }
    
                > span:last-child {
                    text-align: right;
                }
            }
        }
    }
`

class BrokerInfoSection extends Component {
    
    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }

    toggle = () => {
        this.setState({ expanded: !this.state.expanded})
    }

    render() {

        var classNamesForMobile = classNames({
            'mobile': true,
            'expanded': this.state.expanded
        });

        return (
            <Wrapper>
                <Desktop>
                    <h2>{this.props.title}</h2>
                    <div className={this.props.ulClassName} dangerouslySetInnerHTML={{ __html: this.props.data}}/>
                </Desktop>
                <Mobile>
                    <h2 onClick={this.toggle} className={classNamesForMobile}>{this.props.title}</h2>
                    <div className={classNamesForMobile + " " + (this.props.ulClassName ? this.props.ulClassName : '')}
                        dangerouslySetInnerHTML={{ __html: this.props.data}}/>
                </Mobile>
            </Wrapper>
        )
    }
}

export default BrokerInfoSection;